var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.044 2.008a6.556 6.556 0 0 0-9.442 0c-2.381 2.448-2.617 6.335-.55 9.069L.242 16.02a.87.87 0 0 0 0 1.207.814.814 0 0 0 1.174 0l4.809-4.944c2.784 2.225 6.77 1.84 9.104-.878 2.332-2.719 2.208-6.834-.286-9.397Zm-1.174 8.501a4.926 4.926 0 0 1-7.093.001h-.002C5.341 9.033 4.911 6.814 5.688 4.886c.776-1.928 2.606-3.185 4.635-3.185 2.03 0 3.858 1.257 4.635 3.185.776 1.928.347 4.147-1.088 5.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.604 6.01h-1.451V4.518a.842.842 0 0 0-.83-.853.842.842 0 0 0-.83.853V6.01H8.042a.842.842 0 0 0-.83.854c0 .471.371.854.83.854h1.45V9.21c0 .471.372.853.83.853.46 0 .83-.382.83-.853V7.718h1.452c.458 0 .83-.383.83-.854a.842.842 0 0 0-.83-.854Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.40d9b46d963edbdbbb391b70175b4cf3.svg";
export { ForwardRef as ReactComponent };